export default __webpack_public_path__ + "static/media/research.845f6a90.svg";